function logError(error) {
	// eslint-disable-next-line no-console
	console.error(error);
	throw error;
}

// eslint-disable-next-line import/prefer-default-export
export { logError };
